import axios from 'axios'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || null
  },
  getters: {
    isAuthenticated: state => !!state.token,
    token: state => state.token,
    user: state => state.user
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
      try {
        dispatch('setLoading', true, { root: true })
        const response = await axios.post('/auth/login', credentials)
        const { token, user } = response.data.data
        commit('SET_TOKEN', token)
        commit('SET_USER', user)
        return response
      } catch (error) {
        dispatch('setError', error.response?.data?.message || 'Erreur de connexion', { root: true })
        throw error
      } finally {
        dispatch('setLoading', false, { root: true })
      }
    },
    async register({ commit, dispatch }, userData) {
      try {
        dispatch('setLoading', true, { root: true })
        const response = await axios.post('/auth/register', userData)
        const { token, user } = response.data.data
        commit('SET_TOKEN', token)
        commit('SET_USER', user)
        return response
      } catch (error) {
        dispatch('setError', error.response?.data?.message || 'Erreur d\'inscription', { root: true })
        throw error
      } finally {
        dispatch('setLoading', false, { root: true })
      }
    },
    async fetchUser({ commit, dispatch }) {
      try {
        dispatch('setLoading', true, { root: true })
        const response = await axios.get('/auth/me')
        const { user } = response.data.data
        commit('SET_USER', user)
        return user
      } catch (error) {
        dispatch('setError', error.response?.data?.message || 'Erreur de récupération du profil', { root: true })
        throw error
      } finally {
        dispatch('setLoading', false, { root: true })
      }
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
}